"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var Tab = /** @class */ (function (_super) {
    tslib_1.__extends(Tab, _super);
    function Tab(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onClick = function () {
            var _a = _this.props, onClick = _a.onClick, name = _a.name, hash = _a.hash;
            var onTabClick = _this.context.onTabClick;
            onClick(name);
            onTabClick && onTabClick(name, hash);
        };
        _this.handleHashChange = _this.handleHashChange.bind(_this);
        return _this;
    }
    Tab.prototype.componentDidMount = function () {
        if (this.props.hash) {
            this.handleHashChange();
        }
    };
    Tab.prototype.componentWillUnmount = function () {
        var selfHash = this.props.hash, hash = window.location.hash;
        if (selfHash && hash && hash === "#" + selfHash) {
            window.location.hash = "";
        }
    };
    Tab.prototype.handleHashChange = function () {
        var selfHash = this.props.hash, hash = window.location.hash;
        if (selfHash && hash && hash === "#" + selfHash) {
            this.onClick();
        }
    };
    Tab.prototype.componentDidUpdate = function (prevProps) {
        var onLayoutChanged = this.context.onLayoutChanged;
        if (onLayoutChanged && prevProps.isInvalid !== this.props.isInvalid) {
            onLayoutChanged();
        }
    };
    Tab.prototype.render = function () {
        var _a;
        var _b = this.props, label = _b.label, className = _b.className, theme = _b.theme, active = _b.active, onClick = _b.onClick, isInvalid = _b.isInvalid, others = tslib_1.__rest(_b, ["label", "className", "theme", "active", "onClick", "isInvalid"]);
        var classes = classnames_1.default(theme.tab, className, (_a = {},
            _a[theme.active] = active || this.context.activeTabName === this.props.name,
            _a[theme.invalid] = isInvalid,
            _a));
        return (React.createElement("button", tslib_1.__assign({}, others, { onClick: this.onClick, className: classes, type: "button" }),
            label,
            isInvalid ? React.createElement(icon_1.Icon, { iconName: "icon-warning", className: theme.sign, size: 1.4 }) : null));
    };
    Tab.defaultProps = {
        active: false,
        onClick: utils_1.noop
    };
    Tab.contextTypes = {
        onTabClick: PropTypes.func,
        activeTabName: PropTypes.string,
        onLayoutChanged: PropTypes.func
    };
    return Tab;
}(React.Component));
exports.default = Tab;
